module.exports = __webpack_public_path__ + "static/media/arrow-up-drop-down.fdef9995.svg";